/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-07-14 10:11:08
 * @LastEditors: linxi
 * @LastEditTime: 2025-08-25 15:21:34
 */
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  notification,
  Popover,
  Row,
  Select,
} from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import React, { useEffect, useState } from 'react'
import { unwrapResult } from '@reduxjs/toolkit'
import moment from 'moment'
import { RecipeItemInput } from '../../treatment/editor/components/RecipeItemInput'
import { ItemCompletionType } from '../../completion/completionSlice'
import { PlusOutlined, QuestionCircleTwoTone } from '@ant-design/icons'
import { getQualityControlCategory } from '../../../models/commodity'
import {
  getTAHManagementDetailAsync,
  getTAHManagementSubmitAsync,
} from './TAHManagementSlice'
import { DateTimeFormat } from '../../../models/datetime'
import { getTAHLocationListAsync } from '../TAHLocation/TAHLocationSlice'
import { AddOrEditFormLocationModal } from '../TAHLocation/addOrEditModal'
import useSelection from 'antd/es/table/hooks/useSelection'
import { selectTenantId } from '../../../app/applicationSlice'
const { Option } = Select

export const AddOrEditFormModal = (props: {
  editTenantId?: any
  isEdit?: any
  id?: any
  isModalVisible: boolean
  onOk: () => void
  onCancel: () => void
}) => {
  const [form] = Form.useForm()

  const dispatch = useDispatch<RootDispatch>()

  const tenantId = useSelector(selectTenantId)

  const [confirmLoading, setConfirmLoading] = useState(false)

  const [detail, setDetail] = useState<any>()

  const [locationList, setLocationList] = useState<any>()

  const [isModalVisible, setIsModalVisible] = useState(false)

  const [id, setId] = useState<any>()

  const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
  }

  const layouts = {
    labelCol: { span: 3 },
    wrapperCol: { span: 21 },
  }
  const getDetail = () => {
    dispatch(
      getTAHManagementDetailAsync({
        id: props?.id,
        tenantId: props?.editTenantId,
      })
    )
      .then(unwrapResult)
      .then((v: any) => {
        setDetail(v)

        form.setFieldsValue({
          ...v,
          recordDate: v?.recordDate ? moment(v?.recordDate) : '',
          localId: undefined,
          temperatureRange: '',
          humidityRange: '',
        })

        dispatch(
          getTAHLocationListAsync({
            current: 1,
            size: 10000,
            tenantId: tenantId,
          })
        )
          .then(unwrapResult)
          .then((res: any) => {
            setLocationList(res.records)

            const selectData = res.records?.find(
              (val: any) => val?.id == v?.localId
            )

            form.setFieldsValue({
              localId: selectData != undefined ? v?.localId : undefined,
              temperatureRange:
                selectData != undefined
                  ? selectData?.temperatureRangLow +
                    '℃' +
                    '~' +
                    selectData?.temperatureRangHight +
                    '℃'
                  : '',
              humidityRange:
                selectData != undefined
                  ? selectData?.humidityRangLow +
                    '%' +
                    '~' +
                    selectData?.humidityRangHight +
                    '%'
                  : '',
            })
          })
      })
  }

  const getLocationList = () => {
    dispatch(
      getTAHLocationListAsync({ current: 1, size: 10000, tenantId: tenantId })
    )
      .then(unwrapResult)
      .then((res: any) => {
        setLocationList(res.records)
      })
  }

  useEffect(() => {
    if (isModalVisible) {
      setId('')
    }
  }, [isModalVisible])

  useEffect(() => {
    if (props.isModalVisible) {
      if (props?.id) {
        getDetail()
      } else {
        getLocationList()
      }
    } else {
      form.resetFields()
      setLocationList([])
      setDetail({})
    }
  }, [props.isModalVisible, props?.id])

  return (
    <>
      <Modal
        width={800}
        title={
          props?.isEdit == '0'
            ? '查看详情'
            : props?.id
            ? '编辑数据'
            : '添加数据'
        }
        visible={props.isModalVisible}
        footer={null}
        maskClosable={false}
        destroyOnClose={false}
        onCancel={() => {
          props.onCancel()
        }}
        onOk={() => {
          props?.onOk()
        }}
      >
        <Form
          autoComplete='off'
          form={form}
          onFinish={(vs) => {
            const selectData = locationList?.find(
              (val: any) => val?.id == vs?.localId
            )
            setConfirmLoading(true)
            const params = props?.id
              ? {
                  ...detail,
                  ...vs,
                  id: detail?.id,
                  local: selectData?.local,
                }
              : {
                  ...vs,
                  local: selectData?.local,
                }
            dispatch(
              getTAHManagementSubmitAsync({
                ...params,
                temperatureRange: undefined,
                humidityRange: undefined,
                recordDate: params?.recordDate
                  ? moment(params?.recordDate)?.format(DateTimeFormat)
                  : undefined,
              })
            )
              .then(unwrapResult)
              .then((v: any) => {
                notification.success({
                  message: '操作成功',
                })
              })
              .finally(() => {
                props?.onOk()
                setConfirmLoading(false)
              })
          }}
        >
          <Row>
            <Col span={12}>
              <Form.Item {...layout} label='位置' name='localId'>
                <Select
                  placeholder='位置'
                  allowClear
                  onChange={(v) => {
                    const selectData = locationList?.find(
                      (val: any) => val?.id == v
                    )
                    form.setFieldsValue({
                      localId: selectData?.id,
                      temperatureRange:
                        selectData?.temperatureRangLow +
                        '℃' +
                        '~' +
                        selectData?.temperatureRangHight +
                        '℃',
                      humidityRange:
                        selectData?.humidityRangLow +
                        '%' +
                        '~' +
                        selectData?.humidityRangHight +
                        '%',
                    })
                  }}
                >
                  {locationList?.map((v: any, index: any) => {
                    return (
                      <Option value={v?.id} key={index}>
                        {v?.local}
                      </Option>
                    )
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col span={3}>
              <Button
                disabled={props?.isEdit == '0' ? true : false}
                type='link'
                icon={<PlusOutlined />}
                onClick={() => setIsModalVisible(true)}
              >
                新增
              </Button>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Form.Item
                {...layout}
                label='温度范围'
                name='temperatureRange'
                rules={[
                  {
                    required: true,
                    message: '温度范围不能为空',
                  },
                ]}
              >
                <Input placeholder='温度范围' disabled />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                {...layout}
                label='湿度范围'
                name='humidityRange'
                rules={[
                  {
                    required: true,
                    message: '湿度范围不能为空',
                  },
                ]}
              >
                <Input placeholder='湿度范围' disabled />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                {...layout}
                label='温度'
                name='temperature'
                rules={[
                  {
                    required: true,
                    message: '温度不能为空',
                  },
                ]}
              >
                <Input placeholder='温度' addonAfter='℃' type='number' />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                {...layout}
                label='湿度'
                name='humidity'
                rules={[
                  {
                    required: true,
                    message: '湿度不能为空',
                  },
                  {
                    message: '请输入最多带两位小数的数值',
                    pattern: new RegExp(/^[0-9]+((\.)[0-9]{0,2})?$/),
                  },
                ]}
              >
                <Input placeholder='湿度' addonAfter='%' type='number' />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item {...layouts} label='措施' name='measure'>
                <Input placeholder='措施' />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                {...layout}
                label='措施-温度'
                name='temperatureAfterMeasures'
              >
                <Input placeholder='措施-温度' addonAfter='℃' type='number' />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                {...layout}
                label='措施-湿度'
                name='humidityAfterMeasure'
                rules={[
                  {
                    message: '请输入最多带两位小数的数值',
                    pattern: new RegExp(/^[0-9]+((\.)[0-9]{0,2})?$/),
                  },
                ]}
              >
                <Input placeholder='措施-湿度' addonAfter='%' type='number' />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...layout} label='记录时间' name='recordDate'>
                <DatePicker
                  style={{ width: '100%' }}
                  showTime
                  placeholder='有效期'
                  format={DateTimeFormat}
                  onChange={() => {
                    return
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item {...layout} label='备注' name='remark'>
                <Input placeholder='备注' />
              </Form.Item>
            </Col>
          </Row>
          {props?.isEdit == '0' ? (
            <></>
          ) : (
            <Row
              style={{
                marginTop: '20px',
                display: 'flex',
                justifyContent: 'flex-end',
              }}
            >
              <Button
                loading={confirmLoading}
                type='primary'
                onClick={() => {
                  form.submit()
                }}
                style={{ marginRight: '10px' }}
              >
                确定
              </Button>
              <Button
                type='primary'
                ghost
                style={{ marginRight: '10px' }}
                onClick={() => {
                  props?.onCancel()
                }}
              >
                取消
              </Button>
            </Row>
          )}
        </Form>
      </Modal>
      {/* 新增或编辑 */}
      <AddOrEditFormLocationModal
        id={id}
        isModalVisible={isModalVisible}
        onCancel={() => {
          setIsModalVisible(false)
          setId('')
        }}
        onOk={() => {
          setIsModalVisible(false)
          setId('')
          getLocationList()
        }}
      />
    </>
  )
}
